import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'

export const AuthLayout = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
      p: { xs: 2, md: 3 },
    }}
  >
    <Outlet />
  </Box>
)
